(function (angular) {
    angular.module('app.sgdpppurchase', [
        'ui.keypress',
        'vcRecaptcha'
    ]);

}(angular));